import { render, staticRenderFns } from "./LibraryIcon.vue?vue&type=template&id=a16f0618&scoped=true&"
import script from "./LibraryIcon.vue?vue&type=script&lang=ts&"
export * from "./LibraryIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LibraryIcon.vue?vue&type=style&index=0&id=a16f0618&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16f0618",
  null
  
)

export default component.exports